import { Ajax } from '../Core/Ajax';
import { Constants } from '../Core/Constants';

export class ReturnRequestProvider {

	static identify(data, success, error) {
		Ajax.post(Constants.Url.ReturnRequestIdentify, data,
			() => { if (success) success(); },
			(xhr) => { if (error) error(Ajax.GetError(xhr)); }
		);
	}

	static getAccess(token, success, error) {
		Ajax.get(Constants.Url.ReturnRequestAccess, 'token=' + token,
			(data) => { if (success) success(data); },
			(xhr) => { if (error) error(Ajax.GetError(xhr)); }
		);
	}

	static getAccessForOrder(orderId, success, error) {
		Ajax.get(Constants.Url.ReturnRequestAccessForOrder, 'orderId=' + orderId,
			(data) => { if (success) success(data); },
			(xhr) => { if (error) error(Ajax.GetError(xhr)); }
		);
	}

	static submit(data, success, error) {
		Ajax.post(Constants.Url.ReturnRequestSubmit, data,
			(data) => { if (success) success(data); },
			(xhr) => { if (error) error(Ajax.GetError(xhr)); }
		);
	}
}
